export default __webpack_public_path__ + "static/media/opensea.95d69cc4.svg";